/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { UpdatePersonTokenLimitRequestDto } from '../models/update-person-token-limit-request-dto';
import { UpdateProjectTokenLimitRequestDto } from '../models/update-project-token-limit-request-dto';

@Injectable({
  providedIn: 'root',
})
export class AiUsageControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation aiUsageControllerUpdatePersonTokenLimit
   */
  static readonly AiUsageControllerUpdatePersonTokenLimitPath = '/ai/usage/person-token-limit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePersonTokenLimit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePersonTokenLimit$Response(params?: {
    body?: UpdatePersonTokenLimitRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, AiUsageControllerService.AiUsageControllerUpdatePersonTokenLimitPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updatePersonTokenLimit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePersonTokenLimit(params?: {
    body?: UpdatePersonTokenLimitRequestDto
  }): Observable<any> {

    return this.updatePersonTokenLimit$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation aiUsageControllerUpdateProjectTokenLimit
   */
  static readonly AiUsageControllerUpdateProjectTokenLimitPath = '/ai/usage/project-token-limit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProjectTokenLimit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProjectTokenLimit$Response(params?: {
    body?: UpdateProjectTokenLimitRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, AiUsageControllerService.AiUsageControllerUpdateProjectTokenLimitPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateProjectTokenLimit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProjectTokenLimit(params?: {
    body?: UpdateProjectTokenLimitRequestDto
  }): Observable<any> {

    return this.updateProjectTokenLimit$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

}
